
import { showModal } from "../modal/modal.actions";
import { RootState } from "../../store/rootReducer";
import { DokumenKerjasamaCreateResponse } from "./types";
import { UploadFileResponse } from "../../interfaces/UploadFile";
import { put, call, takeEvery, select } from "redux-saga/effects";
import * as dokumenKerjasamaActions from "./dokumenKerjasama.actions";
import { apiPost, apiUpload, BASE_URL, retrieveToken } from "../../store/api";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import validateDokumenKerjasama from "./dokumenKerjasama.saga.validate";

export function* createDokumenKerjasama(
  action: ReturnType<typeof dokumenKerjasamaActions.createDokumenKerjasamaAsync.request>
) {
  try {
    const errors = validateDokumenKerjasama(action.payload);

    if (errors.data && errors.data.length > 0) {
      yield put(dokumenKerjasamaActions.createDokumenKerjasamaAsync.failure(errors));
      return;
    }

    const token: string = yield retrieveToken();
    let payload = {...action.payload};

    // upload
    const fileState = (state: RootState) => state.dokumenKerjasama.selectedFile;
    const file: File = yield select(fileState);

    if (file) {
      const filename = `${action.payload.DOK_ID}${file.name.trim().replace(/[^0-9a-z]/gi, '').toLowerCase()}`;
      const urlUpload = BASE_URL + `dokumen/upload`;

      const blob = new FormData();
      blob.append("filename", filename);
      blob.append("file", file);

      const resultUpload: Response = yield call(apiUpload, urlUpload, token, blob);

      if (resultUpload.status === 200 || resultUpload.status === 201) {
        const parsed: UploadFileResponse = yield call(resultUpload.json.bind(resultUpload));
        payload.DOK_FILE_NAME = parsed.data.fileName;
      } else {
        const parsed: ErrorResponse = yield call(resultUpload.json.bind(resultUpload));
        yield put(showModal(
          'Data gagal disimpan!',
          'Berkas yang Anda pilih tidak dapat diunggah. Mohon periksa ukuran, ekstensi, dan nama berkas.' + 
          '<ul>' +
          '<li>Berkas yang didukung hanyalah PDF dengan ukuran maksimum 10 MB.</li>' +
          '<li>Nama berkas hanya boleh terdiri dari huruf dan angka.</li>' +
          '</ul>'
        ));
        yield put(dokumenKerjasamaActions.createDokumenKerjasamaAsync.failure(parsed));
        return;
      }
    }

    // update
    const url = BASE_URL + 'dokumen';
    const result: Response = yield call(apiPost, url, token, payload);

    if (result.status === 201) {
      const parsed: DokumenKerjasamaCreateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(dokumenKerjasamaActions.createDokumenKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(dokumenKerjasamaActions.createDokumenKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Terjadi kesalahan pada server', 'Silahkan coba kembali dalam beberapa saat'));
    yield put(dokumenKerjasamaActions.createDokumenKerjasamaAsync.failure(parsed));
  }
}

export default function* dokumenKerjasamaSagaCreateDokumenKerjasama() {
  yield takeEvery(dokumenKerjasamaActions.createDokumenKerjasamaAsync.request, createDokumenKerjasama);
}
